import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import cn from 'classnames'
import { pushClearSearch, pushSearchOpen } from '../../../../helpers/gtm'
import setSearchUrlHolder from '../../actions/setSearchUrlHolder'
import setHoldKeyword from '../../actions/setHoldKeyword'
import setSearchResultsKeyword from '../../actions/setSearchResultsKeyword'

import './header-search.scss'
import {pageView} from "../../helpers/drupalSettings"
import {HOMEPAGE_VIEW} from "../../constants"

class HeaderSearch extends PureComponent {

  componentDidMount() {
    const { setSearchUrlHolderAction, setHoldKeywordAction } = this.props
    setHoldKeywordAction('')
  }

  onClearSearchHandler = (e) => {
    const {
      setSearchUrlHolderAction,
      setHoldKeywordAction,
      setSearchResultsKeywordAction,
    } = this.props
    e.stopPropagation()
    setSearchUrlHolderAction('')
    setHoldKeywordAction('')
    setSearchResultsKeywordAction('')
    this.keywordRef.value = ''
    pushClearSearch()
  }

  getKeyword = () => {
    const { keyword, holdKeyword } = this.props
    return holdKeyword || keyword
  }

  handleSearchClick = (e) => {
    const { onClick } = this.props
    onClick(e)
  }

  handleSearchSubmitClick = (e) => {
    const { onSubmit } = this.props
    onSubmit(e)
  }

  openSearchClick = (e) => {
    const { onClick } = this.props
    pushSearchOpen()
    onClick(e)
  }

  render() {
    const {
      placeholder,
      searchButtonValue,
      holdKeyword,
      searchResultsKeyword,
      globalLoading,
    } = this.props

    return (
      <div className="header-search">
        <div className="header-search__search-icon">
          <svg aria-labelledby="NEWSEARCH">
            <use xlinkHref="#NEWSEARCH" />
          </svg>
        </div>
        <input
          ref={(keyword) => { this.keywordRef = keyword }}
          className={cn('header-search__search-text', (holdKeyword || searchResultsKeyword) && 'active')}
          id="header-search-field"
          placeholder={placeholder}
          type="text"
          name="keyword"
          value={this.getKeyword()}
          onClick={this.openSearchClick}
          autoComplete="off"
          readOnly
        />

        { (holdKeyword || searchResultsKeyword) && (
          <label htmlFor="header-search-field" className="input-control__label">
            {placeholder}
          </label>
        )}
        {holdKeyword && (
          <div
            className="header-search__clear"
            role="button"
            onClick={this.onClearSearchHandler}
          >
            <span className={cn('clear-input')}>
              <span className="x-icon" />
            </span>
          </div>
        )}
        <input
          className={cn('header-search__search-button homePageSearch', globalLoading && 'disabled')}
          type="button"
          value={searchButtonValue}
          onClick={this.handleSearchSubmitClick}
        />
      </div>
    )
  }
}


HeaderSearch.defaultProps = {
  placeholder: '',
  holdKeyword: '',
  pageView: '',
  searchResultsKeyword: '',
}

HeaderSearch.propTypes = {
  placeholder: PropTypes.string,
  searchButtonValue: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  showFilters: PropTypes.bool.isRequired,
  clearSearch: PropTypes.string.isRequired,
  keyword: PropTypes.string.isRequired,
  pageView: PropTypes.string,
  holdKeyword: PropTypes.string,
  setSearchUrlHolderAction: PropTypes.func.isRequired,
  setHoldKeywordAction: PropTypes.func.isRequired,
  setSearchResultsKeywordAction: PropTypes.func.isRequired,
  searchResultsKeyword: PropTypes.string,
  globalLoading: PropTypes.bool.isRequired,
}

const mapStateToProps = ({
  main: {
    holdKeyword,
    searchResultsKeyword,
    homePageVideoBanner,
  },
  browser,
  globalLoader: {
    isShow,
  },
}) => ({
  holdKeyword,
  browser,
  homePageVideoBanner,
  searchResultsKeyword,
  globalLoading: isShow,
})

const mapDispatchToProps = {
  setSearchUrlHolderAction: setSearchUrlHolder,
  setHoldKeywordAction: setHoldKeyword,
  setSearchResultsKeywordAction: setSearchResultsKeyword,
}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderSearch)
